








// Bind all Variant IDs for the upsell page 
const UPSELL_VARIANT_IDS = '40760456085672,40760456118440,40760456151208,40760456183976,40760456216744,43524127752413,43524148920541,43524159045853,43524179787997,43524192338141,43524212326621,43524218388701,44407846568157,44407846600925,45291212701917,43184033890525,46868630798557,46868630831325,46868630864093,46868630896861,46623170953437,46359655678173,47044722720989,46868704461021,46868704493789,46868704526557'.split(',');

// Declaring the Cart Data
let cartData = null;

$(document).ready(function () {
  $(window).scroll(function () {
    var element = $(".access-mid-left");

    // Get the offset of the element from the top of the document
    var offset = element.offset();

    // Calculate the distance from the top of the window
    var distanceFromTop = offset.top - $(window).scrollTop();

    if (distanceFromTop > 130) {
      $("#comfortfit-watch, #charging-access, #active-watch").addClass(
        "distanceTop"
      );
    }

    if ($(this).scrollTop() >= 95) {
      $(".access-mid-left").addClass("fixedOnTop");
    } else {
      click = 0;
      $(".access-mid-left").removeClass("fixedOnTop");
    }
    scrollfn();
  });
});

function fadeOut() {
  setTimeout(function () {
    $(".addedToCart_alert").fadeOut();
  }, 2000);
}

// script for scroll part
const tabnavs = document.querySelector(".tabnavs");
const navtabitem = document.querySelectorAll(".navtab-item");

tabnavs.addEventListener("click", function (e) {
  if (e.target.classList.contains("navtab-item")) {
    e.preventDefault();

    const id = e.target.getAttribute("href");
    const sectionElement = document.querySelector(`${id}`);
    sectionElement.scrollIntoView({ behavior: "smooth" });
  }
});

// script for active tab part
navtabitem.forEach((nabitem) => {
  nabitem.addEventListener("click", function (e) {
    const link = e.target;
    const siblings = link
      .closest(".tabnavs")
      .querySelectorAll(".navtab-item");
    // console.log(siblings);
    siblings.forEach((sibling) => {
      if (sibling != link) {
        sibling.classList.remove("active");
      } else {
        sibling.classList.add("active");
      }
    });
  });
});

//script to change tab text on mobile view
const activefittab = document.getElementById("activefit");
const comfortit = document.getElementById("comfortfit");
// console.log(activefittab);

if (window.innerWidth < 767) {
  activefittab.textContent = "Active-fit bands";
  comfortit.textContent = "Comfort-fit bands";
} else {
  activefittab.textContent = "Active-fit watch bands";
  comfortit.textContent = "Comfort-fit watch bands";
}

function scrollfn() {
  var scrollDistance = $(".access-mid-right").scrollTop();
  if (scrollDistance == 0) {
    scrollDistance = $(window).scrollTop(); // calculating for lanscape view as thee whole window is scrolling
  }

  if (scrollDistance >= 0 && scrollDistance <= 300) {
    $(".navtab-item").removeClass("active");
    $("#new").addClass("active");
  } else if (scrollDistance >= 300 && scrollDistance <= 600) {
    $(".navtab-item").removeClass("active");
    $("#bundelcoll").addClass("active");
  } else if (scrollDistance > 600 && scrollDistance <= 1300) {
    $(".navtab-item").removeClass("active");
    $("#activefit").addClass("active");
  } else if (scrollDistance > 1300 && scrollDistance <= 2500) {
    $(".navtab-item").removeClass("active");
    $("#comfortfit").addClass("active");
  } else if (scrollDistance > 2500  && scrollDistance <= 2900) {
    $(".navtab-item").removeClass("active");
    $("#chargingcable").addClass("active");
  }
  else if (scrollDistance > 2900) {
    $(".navtab-item").removeClass("active");
    $("#screenprotector").addClass("active");
  }
  moveBand();
}

$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 245) {
      $(".access-mid-left").addClass("fixedOnTop");
    } else {
      $(".access-mid-left").removeClass("fixedOnTop");
    }
  });
});

$("#timepicker li").on("click", function () {
  //max left scroll
  var maxScrollLeft =
    $("#timepicker").scrollLeft("#timepicker").prop("scrollWidth") -
    $("#timepicker").width();
  var left = $(this).offset().left;

  var width = $("#timepicker").width();
  var diff = left - width / 3.5;
  $("#timepicker").scrollLeft($("#timepicker").scrollLeft() + diff);
});

function moveBand() {
  var left = $("#timepicker").find(".active").offset().left;

  var width = $("#timepicker").width();
  var diff = left - width / 3.5;
  $("#timepicker").scrollLeft($("#timepicker").scrollLeft() + diff);
}

$(window).scroll(function () {
  var scrollDistance = $(window).scrollTop();

  $(".acces-prodwrap").each(function (i) {
    if ($(this).position().top <= scrollDistance) {
      $(".navtab-item .active").removeClass("active");
      $(".navtab-item").eq(i).addClass("active");
    }
  });
}).scroll();

$(document).ready(async function () {
  $(".cartMinus").click(async function (e) {
    if ($(this).parent().parent(".inputwrap").hasClass('in-progress')) return;

    var variant_id = $(this).parent().parent(".inputwrap").siblings(".prod-btn").children("button").attr("id");
    if(variant_id) {
      $(this).parent().parent(".inputwrap").addClass('in-progress');

      const cartItem = (cartData?.lines?.edges ?? []).find((obj) => {
        return obj.node.merchandise.id == `gid://shopify/ProductVariant/${variant_id}`;
      })
      
      if(cartItem) {
        var qty = $(this).parent().next('.input-box').val();
        var newQty = parseInt(parseInt(qty) - 1);
        if(newQty > 0) {
          $(this).parent().next('.input-box').val(newQty);

          if(newQty == 1) {
            $(`button[id="${variant_id}"]`).parent().siblings(".inputwrap").find('.cartTrash').css("display", "inline-block");
            $(`button[id="${variant_id}"]`).parent().siblings(".inputwrap").find('.cartMinus').css("display", "none");
          } else {
            $(`button[id="${variant_id}"]`).parent().siblings(".inputwrap").find('.cartTrash').css("display", "none");
            $(`button[id="${variant_id}"]`).parent().siblings(".inputwrap").find('.cartMinus').css("display", "inline-block");
          }

          await updateCartItem({
            variant_id: variant_id,
            id: cartItem?.node?.id,
            quantity: newQty,
          });

          var prod = $(`button[id="${variant_id}"]`).parent().siblings(".prodwrap").children(".prodinfo").find(".prod-name").text();
          $("#itemtitle").text(prod);
          $("#actioncart").text('Updated the cart!!');
          $(".addedToCart_alert").fadeIn("fast", fadeOut);
        } else {
          await removeCartItem(cartItem?.node?.id);
        }

        refreshUpsellPage();
      }

      setTimeout(() => {
        $(this).parent().parent(".inputwrap").removeClass('in-progress');
      }, 1000);
    }
  });

  $(".cartPlus").click(async function (e) {
    if ($(this).parent().parent(".inputwrap").hasClass('in-progress')) return;

    var variant_id = $(this).parent().parent(".inputwrap").siblings(".prod-btn").children("button").attr("id");
    if(variant_id) {
      $(this).parent().parent(".inputwrap").addClass('in-progress');

      const cartItem = (cartData?.lines?.edges ?? []).find((obj) => {
        return obj.node.merchandise.id == `gid://shopify/ProductVariant/${variant_id}`;
      })

      if(cartItem) {
        var qty = $(this).parent().prev('.input-box').val();
        var newQty = parseInt(parseInt(qty) + 1);

        $(this).parent().prev('.input-box').val(newQty);

        if(newQty == 1) {
          $(`button[id="${variant_id}"]`).parent().siblings(".inputwrap").find('.cartTrash').css("display", "inline-block");
          $(`button[id="${variant_id}"]`).parent().siblings(".inputwrap").find('.cartMinus').css("display", "none");
        } else {
          $(`button[id="${variant_id}"]`).parent().siblings(".inputwrap").find('.cartTrash').css("display", "none");
          $(`button[id="${variant_id}"]`).parent().siblings(".inputwrap").find('.cartMinus').css("display", "inline-block");
        }
          
        await updateCartItem({
          variant_id: variant_id,
          id: cartItem?.node?.id,
          quantity: newQty,
        });
      } else {
        $(this).parent().prev('.input-box').val(1);

        await addCartItem({
          variant_id: variant_id,
          quantity: 1,
        });
      }

      var prod = $(`button[id="${variant_id}"]`).parent().siblings(".prodwrap").children(".prodinfo").find(".prod-name").text();
      $("#itemtitle").text(prod);
      $("#actioncart").text('Added to cart!');
      $(".addedToCart_alert").fadeIn("fast", fadeOut);

      refreshUpsellPage();

      setTimeout(() => {
        $(this).parent().parent(".inputwrap").removeClass('in-progress');
      }, 1000);
    }
  });

  $(".cartTrash").click(async function (e) {
    if ($(this).parent().parent(".inputwrap").hasClass('in-progress')) return;

    var variant_id = $(this).parent().parent(".inputwrap").siblings(".prod-btn").children("button").attr("id");
    if(variant_id) {
      $(this).parent().parent(".inputwrap").addClass('in-progress');

      const cartItem = (cartData?.lines?.edges ?? []).find((obj) => {
        return obj.node.merchandise.id == `gid://shopify/ProductVariant/${variant_id}`;
      });
      
      if(cartItem) {
        await removeCartItem(cartItem?.node?.id);

        refreshUpsellPage();
      }

      setTimeout(() => {
        $(this).parent().parent(".inputwrap").removeClass('in-progress');
      }, 1000);
    }
  });

  refreshUpsellPage()      
});

async function addtocart(param, isSellingPlanAvailable = false) {
  $(param).addClass("disabled");
  
  const variant_id = param.id;

  const payload = {
    variant_id: variant_id,
    quantity: 1,
  }

  if (isSellingPlanAvailable === true) {
    payload.selling_plan_id = $(param).parent()?.find('[name="selling-plan-id"]')?.val();
  }

  if (await addCartItem(payload)) {
    $("#actioncart").text("Added to cart!");
    $(param).removeClass("disabled");

    refreshUpsellPage();

    var prod = $(param).parent().siblings(".prodwrap").children(".prodinfo").find(".prod-name").text();
    $("#itemtitle").text(prod);
    $(".addedToCart_alert").fadeIn("fast", fadeOut);
  } else {
    $(param).removeClass("disabled");
  }
}

async function refreshUpsellPage() {
  cartData = await fetchCart();
  if(cartData) {
    if ((cartData?.discountCodes ?? []).findIndex((obj) => obj.code == 'AC-F6XPECM7') >= 0) {
      $('#upsell-disc-tag')?.show();
    } else {
      $('#upsell-disc-tag')?.hide();
    }

    for (const vId of UPSELL_VARIANT_IDS) {
      const cartItem = (cartData?.lines?.edges ?? []).find((obj) => {
        return obj.node.merchandise.id == `gid://shopify/ProductVariant/${vId}`;
      })
      
      var param = $(`button[id="${vId}"]`);
      
      if(cartItem) {
        $(param).hide();
        $(param).parent().siblings(".inputwrap").css("display", "inline-block");
        $(param).parent().siblings(".inputwrap").find(".input-box").val(cartItem?.node?.quantity);

        if(cartItem?.node?.quantity == 1) {
          $(param).parent().siblings(".inputwrap").find('.cartTrash').css("display", "inline-block");
          $(param).parent().siblings(".inputwrap").find('.cartMinus').css("display", "none");
        } else {
          $(param).parent().siblings(".inputwrap").find('.cartMinus').css("display", "inline-block");
          $(param).parent().siblings(".inputwrap").find('.cartTrash').css("display", "none");
        }

        if ($(param).parent().siblings(".inputwrap").is('[preorder-input-wrap]')) {
          $(param).parent().siblings(".inputwrap").addClass('preorder-wrap');
        }
      } else {
        $(param).parent().siblings('.inputwrap').hide();              
        $(param).show();
        $(param).parent('.prod-btn').show();

        if ($(param).parent().siblings(".inputwrap").is('[preorder-input-wrap]')) {
          $(param).parent().siblings(".inputwrap").removeClass('preorder-wrap');
        }
      }
    }
  }
}

function addCartItem(lineItem) {
  return new Promise((resolve, reject) => {
    const cartId = localStorage.getItem('shopify-gql-cartid');
    if (cartId) {
      jQuery.ajax({
        url: `${ACTIVATIONAPI_BASEURL}/shopify/cart/lines/add`,
        type: "POST",
        contentType: "application/json",
        dataType: "JSON",
        processData: false,
        data: JSON.stringify({
          cart_id: cartId,
          items: Array.isArray(lineItem) ? lineItem : [lineItem],
        }),
      }).done(function (response) {
        return resolve(true);
      }).fail(function (error) {
        showErrorMessage(error, "Failed to Add to Cart");
        return resolve(false);
      });
    } else {
      notify('error', "Failed to Add to Cart", "We encountered an issue while retrieving your data. Please try starting from the first step.")
      return resolve(false);
    }
  })
}

function updateCartItem(lineItem) {
  return new Promise((resolve, reject) => {
    const cartId = localStorage.getItem('shopify-gql-cartid');
    if (cartId) {
      jQuery.ajax({
        url: `${ACTIVATIONAPI_BASEURL}/shopify/cart/lines/update`,
        type: "POST",
        contentType: "application/json",
        dataType: "JSON",
        processData: false,
        data: JSON.stringify({
          cart_id: cartId,
          items: Array.isArray(lineItem) ? lineItem : [lineItem],
        }),
      }).done(function (response) {
        return resolve(true);
      }).fail(function (error) {
        showErrorMessage(error, "Failed to Update Cart");
        return resolve(false);
      });
    } else {
      notify('error', "Failed to Update Cart", "We encountered an issue while retrieving your data. Please try starting from the first step.")
      return resolve(false);
    }
  })
}

function removeCartItem(lineItemId) {
  return new Promise((resolve, reject) => {
    const cartId = localStorage.getItem('shopify-gql-cartid');
    if (cartId) {
      jQuery.ajax({
        url: `${ACTIVATIONAPI_BASEURL}/shopify/cart/lines/remove`,
        type: "POST",
        contentType: "application/json",
        dataType: "JSON",
        processData: false,
        data: JSON.stringify({
          cart_id: cartId,
          line_ids: Array.isArray(lineItemId) ? lineItemId : [lineItemId],
        }),
      }).done(function (response) {
        return resolve(true);
      }).fail(function (error) {
        showErrorMessage(error, "Oops! Removal Failed");
        return resolve(false);
      });
    } else {
      notify('error', "Oops! Removal Failed", "We encountered an issue while retrieving your data. Please try starting from the first step.")
      return resolve(false);
    }
  })
}
